import{d as t}from"./chunk-73U45M5A.js";import{q as a}from"./chunk-MOWIYUQE.js";import{b as s,c as r}from"./chunk-7TW5V77R.js";import{m as o}from"./chunk-HBP5N4FR.js";o();a();var l=()=>{let e=t(s),c=t(r);return{customToasts:e,transactionToasts:c}};export{l as a};
//# sourceMappingURL=chunk-KPG3XDY3.js.map
